import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-deac7e6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "customer-check"
}
const _hoisted_2 = { class: "customer-check__title h4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "customer-check__icon icon icon-arrow-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_ctx.pageContent)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.pageContent.title), 1),
        _createVNode(_component_RadioGroup, {
          modelValue: _ctx.isCustomer,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCustomer) = $event)),
          options: _ctx.options
        }, null, 8, ["modelValue", "options"]),
        _createVNode(_component_AppButton, {
          disabled: _ctx.isCustomer === null,
          class: "customer-check__next-button",
          "full-width": "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('go-forward')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.pageContent.nextStepButtonCopy), 1),
            _hoisted_3
          ], undefined, true),
          _: 1
        }, 8, ["disabled"])
      ]))
    : _createCommentVNode("", true)
}